module.exports = __webpack_public_path__ + "0e47906755861180c3ae820dd7bb5a90.png";